export function replaceLink(content: string): string {
  return content.replace(/href="(\/[^#"]*[^\/])"/g, `href="$1/"`)
}
